import { set } from 'lodash';

import { streamUpdater } from '@swf/core/utils/casino';

export default streamUpdater<Record<string, string>>(
  (game, { gId, vId }) => game.gametype === +gId && game.variant === +vId && set(game, 'fsb', true)
);
